import React, { useState, useEffect } from "react";
import { TrainingWalkthrough } from "./training-walkthrough-view";
export const TrainingWalkthroughController = (props) => {
	const [open, setOpen] = useState(true);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	return <TrainingWalkthrough open={open} handleOpen={handleOpen} handleClose={handleClose} {...props} />;
};
